import * as React from 'react';
import { Drawer, useMediaQuery } from '@material-ui/core';
import WorkcalendarListDesktop from './WorkcalendarListDesktop';
import WorkcalendarListMobile from './WorkcalendarListMobile';
import { List } from 'react-admin';
import workcalendarFilters from './workcalendarFilters';

const WorkcalendarList = ({selectedRow, realResource, ...props}) => {
    const isXSmall = useMediaQuery(theme =>
        theme.breakpoints.down('xs')
    );

    return (
        <List {...props} 
            bulkActionButtons={true}
            filters={workcalendarFilters}
            perPage={25}
            sort={{ field: 'id', order: 'ASC' }}
        >
            {isXSmall ? (
                <WorkcalendarListMobile selectedRow={ selectedRow } />
            ) : ( 
                <WorkcalendarListDesktop selectedRow={ selectedRow } />
            )}
        </List>
    );
}

export default WorkcalendarList